import { Dispatch } from 'redux'

import { create, destroy, update } from 'redux/api/WidgetTags'
import { useThunkActions } from 'redux/actions/useThunkActions'

import {
  WidgetTagPatchAttributes,
  WidgetTagPostAttributes
} from 'types/GlobalWidgetTag'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'

import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

function tryCreateWidgetTag(body: WidgetTagPostAttributes, widgetId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create(body)
      .then((response) => {
        dispatch(
          actions.createSuccess({
            data: response.data.data,
            widgetId: widgetId
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdated))
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdatedFailed))
      })
  }
}

function tryUpdateWidgetTag(
  id: string,
  body: WidgetTagPatchAttributes,
  widgetId: string
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(id, body)
      .then((response) => {
        dispatch(
          actions.updateSuccess({
            data: response.data.data,
            widgetId: widgetId
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdated))
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdatedFailed))
      })
  }
}

function tryDeleteWidgetTag(id: string, widgetId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(
          actions.destroySuccess({
            id,
            widgetId: widgetId
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdated))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdatedFailed))
      })
  }
}

export const useWidgetTagActions = () => {
  return {
    tryCreateWidgetTag: useThunkActions(tryCreateWidgetTag),
    tryUpdateWidgetTag: useThunkActions(tryUpdateWidgetTag),
    tryDeleteWidgetTag: useThunkActions(tryDeleteWidgetTag)
  }
}
